import { Box, FormControl, InputLabel, Select, SelectChangeEvent, MenuItem } from "@mui/material";
import { format } from "date-fns";
import { Controller, UseFormReturn } from "react-hook-form";
import { AvailabilityPreferences, DayPeriod } from "../../utils/types";
import { CLINIC_SCHEDULES } from "../../../../utils/constants";
import { createInitialTimeRanges } from "../../utils/utils";

type PeriodOfDayProps = {
    entityForm: UseFormReturn<AvailabilityPreferences>;
};

export const PeriodOfDay = ({ entityForm }: PeriodOfDayProps) => {
    const scheduleRanges = createInitialTimeRanges(new Date(), "both", CLINIC_SCHEDULES);
    const { control } = entityForm;
    return (
        <Box>
            <Controller
                name="dayPeriod"
                control={control}
                render={({ field }) => (
                    <FormControl fullWidth>
                        <InputLabel>Preferred Time</InputLabel>
                        <Select
                            {...field}
                            label="Período do dia"
                            onChange={(event: SelectChangeEvent<DayPeriod>) => field.onChange(event.target.value as DayPeriod)}
                        >
                            <MenuItem value="morning">
                                Manhã ({format(scheduleRanges[0].start, "HH:mm")} - {format(scheduleRanges[0].end, "HH:mm")})
                            </MenuItem>
                            <MenuItem value="afternoon">
                                Tarde ({format(scheduleRanges[1].start, "HH:mm")} - {format(scheduleRanges[1].end, "HH:mm")})
                            </MenuItem>
                            <MenuItem value="both">Ambos</MenuItem>
                        </Select>
                    </FormControl>
                )}
            />
        </Box>
    );
};
